// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up-card {
  width: 80%;
  margin: 0 auto;
  padding: 3em 0 0 0;
  height: 100%;
  color: var(--purple-mid);
}

.title {
  text-align: center;
  font-family: sans-serif;
  font-size: 2em;
  margin: 1em auto .25em;
  width: 100%;
}

.sign-up-form {
  display: flex;
  padding: 0 3rem;
  flex-direction: column;
  align-items: flex-start;
  background-color: #ffffff;
  max-width: 35em;
  min-height: 570px;
  max-height: 1300px;
  margin: 0 auto 0;
  border-radius: 20px;
}

.sign-up-form .sign-up-title {
  text-decoration: underline;
  text-underline-offset: 0.2rem;
  margin-bottom: 1em;
}

.sign-up-form label {
  text-align: left;
  margin: .5em 0;
  width: 100%;
}

label span {
  float: right;
  color: rgb(255, 60, 0);
}

.sign-up-form input {
  font-family: 'Inter', sans-serif;
  padding: 0 1em;
  margin-bottom: 1.25rem;
  border-style: none;
  border-radius: 4px;
  width: 100%;
  min-height: 2.5em;
  background-color: #D9D9D9;
}

.sign-up-form input:focus {
  outline: none;
  box-shadow: 0 0 0 .25rem var(--purple-mid);
}

.submit-button {
  border: none;
  border-radius: 7px;
  padding: .5em 0;
  margin: auto 0 2em 0;
  width: 100%;
  font-size: 1.25em;
  font-weight: bold;
  color: #fff;
  background-color: var(--purple-drk);
  margin-top: auto;
}

.submit-button:focus {
  outline: none;
  box-shadow: 0 0 0 .25rem var(--purple-drk);
}

.login-signup-link {
  width: 100%;
  color: var(--purple-mid);
  margin: 0 0 3rem 0;
  text-align: center;
}

.login-signup-link>a,
a:hover,
a:visited {
  color: var(--purple-mid);
  font-weight: 700;
}

.error-message {
  color: rgb(255, 60, 0);
}`, "",{"version":3,"sources":["webpack://./src/features/auth/auth.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".sign-up-card {\n  width: 80%;\n  margin: 0 auto;\n  padding: 3em 0 0 0;\n  height: 100%;\n  color: var(--purple-mid);\n}\n\n.title {\n  text-align: center;\n  font-family: sans-serif;\n  font-size: 2em;\n  margin: 1em auto .25em;\n  width: 100%;\n}\n\n.sign-up-form {\n  display: flex;\n  padding: 0 3rem;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: #ffffff;\n  max-width: 35em;\n  min-height: 570px;\n  max-height: 1300px;\n  margin: 0 auto 0;\n  border-radius: 20px;\n}\n\n.sign-up-form .sign-up-title {\n  text-decoration: underline;\n  text-underline-offset: 0.2rem;\n  margin-bottom: 1em;\n}\n\n.sign-up-form label {\n  text-align: left;\n  margin: .5em 0;\n  width: 100%;\n}\n\nlabel span {\n  float: right;\n  color: rgb(255, 60, 0);\n}\n\n.sign-up-form input {\n  font-family: 'Inter', sans-serif;\n  padding: 0 1em;\n  margin-bottom: 1.25rem;\n  border-style: none;\n  border-radius: 4px;\n  width: 100%;\n  min-height: 2.5em;\n  background-color: #D9D9D9;\n}\n\n.sign-up-form input:focus {\n  outline: none;\n  box-shadow: 0 0 0 .25rem var(--purple-mid);\n}\n\n.submit-button {\n  border: none;\n  border-radius: 7px;\n  padding: .5em 0;\n  margin: auto 0 2em 0;\n  width: 100%;\n  font-size: 1.25em;\n  font-weight: bold;\n  color: #fff;\n  background-color: var(--purple-drk);\n  margin-top: auto;\n}\n\n.submit-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 .25rem var(--purple-drk);\n}\n\n.login-signup-link {\n  width: 100%;\n  color: var(--purple-mid);\n  margin: 0 0 3rem 0;\n  text-align: center;\n}\n\n.login-signup-link>a,\na:hover,\na:visited {\n  color: var(--purple-mid);\n  font-weight: 700;\n}\n\n.error-message {\n  color: rgb(255, 60, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
